import './LandingPageV2Style.less';

import React, { Component } from 'react';

import layoutWrapper from '../../hocs/layoutWrapper';
import ListingTypeAheadInput, { IListingTypeAheadOption } from '../common/ListingTypeAheadInput';
import AgentInformationBanner, { IAgentInfoBannerIProps } from './AgentInformationBanner';
import IconChecklist from './IconChecklist';

const SUBMIT_REASON_CHECKLIST_CONFIG = [
  {
    content: (
      <div>
        <h6 className="submit-reason-subheader">Check active offers</h6>
        <div className="submit-reason-text">
          See if the home is FHA eligible and has active offers
          {'.'}
        </div>
      </div>
    ),
    iconName: 'ic-home-info',
  },
  {
    content: (
      <div>
        <h6 className="submit-reason-subheader">Get an offer receipt</h6>
        <div className="submit-reason-text">
          Know the moment the seller receives your client’s offer
          {'.'}
        </div>
      </div>
    ),
    iconName: 'ic-hourglass',
  },
  {
    content: (
      <div>
        <h6 className="submit-reason-subheader">Personalize the offer</h6>
        <div className="submit-reason-text">
          Add documents, details, and a note to the seller
          {'.'}
        </div>
      </div>
    ),
    iconName: 'ic-personalize',
  },
];

const AGENT_OFFER_BANNERS: IAgentInfoBannerIProps[] = [
  {
    description:
      'Refer your client to an Opendoor partner mortgage solution and ask about rate buydowns.',
    isAnnouncement: false,
    learnMoreHref: ' https://app.lower.com/mortgage/lightspeed/warm-up',
    title: 'Get up to $7,500 for your client',
  },
  {
    analyticsIdentifier: 'resale-offer-portal',
    description:
      'If you have a client that needs to sell fast, we can help with that. Request an offer today.',
    isAnnouncement: false,
    learnMoreHref:
      'https://www.opendoor.com/t/f_partnership/c_resaleportal_home/p_agent?route=agents',
    source: 'home',
    title: 'Help a client sell to Opendoor',
  },
];

export interface ILandingPageV2State {
  address: IListingTypeAheadOption;
}

export interface ILandingPageV2Props {
  loading: boolean;
  onSubmit: (listingSlug: string) => void;
}

export class LandingPageV2 extends Component<ILandingPageV2Props, ILandingPageV2State> {
  public state: ILandingPageV2State = {
    address: null,
  };

  public render() {
    const { loading } = this.props;
    const { address } = this.state;

    return (
      <div className="od-agent-resale-landing-page">
        <div className="container">
          <div className="section-header text-large text-dark-gray">Buy with Opendoor</div>
          <div className="row">
            <div className="col-xs-12 col-md-6">
              <h1>
                <div>
                  Submit an offer for <span className="same-row-text">your client</span>
                  <div className="new-row-text">your client</div>
                </div>
              </h1>
              <div className="od-agent-resale-landing-page__address-input-container">
                <div className="text-product-large medium-margin-bottom">
                  What address are they interested in?
                </div>
                <ListingTypeAheadInput
                  name="address"
                  onSelect={this.onAddressSelect}
                  placeholderText="123 Main St."
                  invalidUserInputMessage="Please enter a valid address"
                  showCta={true}
                  ctaProps={{
                    actionText: 'Get started',
                    disabled: !address,
                    loading,
                    onClick: this.onSubmit,
                  }}
                />
              </div>
              <div className="od-agent-resale-landing-page__bonus-commission-banner">
                <div className="text-product-large text-muted small-margin-bottom">
                  Why submit online?
                </div>
                <IconChecklist items={SUBMIT_REASON_CHECKLIST_CONFIG} />
              </div>
            </div>
            <div className="col-xs-12 col-md-offset-1 col-md-5">
              {AGENT_OFFER_BANNERS.map((banner, index) => {
                return <AgentInformationBanner key={index} {...banner} />;
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }

  private onAddressSelect = (name: string, address: IListingTypeAheadOption) => {
    this.setState(prevState => ({
      ...prevState,
      [name]: address,
    }));
  };

  private onSubmit = () => {
    const { onSubmit } = this.props;
    onSubmit(this.state.address.slug);
  };
}

export default layoutWrapper<ILandingPageV2Props>(LandingPageV2, {
  footerType: 'PHOTO',
  headerType: 'MINIMAL',
});
